import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Menu from "../ui/Menu";
import Button from "../ui/Button";
import Float from "../ui/Float";
import ReconciliationSounds from "./ReconciliationSounds";
import { createModal } from "../hooks/createModal";
import { showError, showMessage } from "../ui/Message";
import ExportCounts from "../components/reconciliation/ExportCounts";
import ResetInventory from "../components/reconciliation/ResetInventory";
import FindInventory from "../components/reconciliation/FindInventory";
import { showConfirm } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import PurgeList from "../components/reconciliation/PurgeList";
import ZeroCounts from "../components/reconciliation/ZeroCounts";
import FindIsbns from "../components/reconciliation/FindIsbns";

export default function ReconciliationExtras(props) {

    const { controller="", callback = () => { }, route = "", unique = "E", filters } = props;


    const showSoundSetup = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.SOUNDS;
        createModal({
            component: <ReconciliationSounds controller={controller} route={ROUTES.RECONCILIATION.SOUNDS} />, title: "Reconciliation Sounds (workstation specific)", closable: true, callback: (_r) => {
                if (_r) {
                    showMessage("Sound settings saved")
                }
                window.bm_state.value = route;
            }
        })
    }

    const showExportCounts = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.EXPORT_COUNTS;
        createModal({
            component: <ExportCounts controller={controller} filters={filters} route={ROUTES.RECONCILIATION.EXPORT_COUNTS} />, title: "Export ISBNs and counts", closable: true, callback: (_r) => {
                window.bm_state.value = route;
            }
        })
    }

    const showResetInventory = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.RESET_INVENTORY;
        createModal({
            component: <ResetInventory controller={controller} filters={filters} route={ROUTES.RECONCILIATION.RESET_INVENTORY} />, title: "Reset Inventory 'Counted' flag", closable: true, callback: (_r) => {
                window.bm_state.value = route;
            }
        })
    }

    const showFindInventory = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.FIND_INVENTORY;
        createModal({
            component: <FindInventory controller={controller} route={ROUTES.RECONCILIATION.FIND_INVENTORY} />, alert: true, title: "", closable: true, callback: (_r) => {
                window.bm_state.value = route;
            }
        })
    }

    const showPurge = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.PURGE_LIST;
        createModal({
            component: <PurgeList controller={controller} />, alert: true, title: "", closable: true, callback: (_r) => {
                window.bm_state.value = route;
            }
        })
    }

    const showZeroCounts = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.ZERO_COUNTS;
        createModal({
            component: <ZeroCounts controller={controller} route={ROUTES.RECONCILIATION.ZERO_COUNTS} />, alert: true, title: "", closable: true, callback: (_r) => {
                window.bm_state.value = route;
            }
        })
    }

    const showFindISBNs = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.FIND_ISBNS;
        createModal({
            component: <FindIsbns controller={controller} route={ROUTES.RECONCILIATION.FIND_ISBNS}  />, title: "Find ISBNs not counted", closable: true, callback: (_r) => {
                window.bm_state.value = route;
            }
        })
    }


//[TEMP] SHOW ONLY RECONCILIATION
    const menu = [
        // { unique: "1", key: KBD.Digit1, action: () => showResetInventory(), text: "Reset Inventory 'counted' flag to not counted (entire file or class)" },
        // { unique: "2", key: KBD.Digit2, action: () => showFindISBNs(), text: "Find ISBNs with stock O/H that have not been counted (ie. not on this list)" },
        // { unique: "3", key: KBD.Digit3, action: () => { }, text: "Automatically adjust O/H to counted and post differences" },
        // { unique: "4", key: KBD.Digit4, action: () => { }, text: "Make the classification for all entries the same" },
        // { unique: "5", key: KBD.Digit5, action: () => { }, text: "Adjust Backroom stock levels to match 'counts'" },
        // { unique: "6", key: KBD.Digit6, action: () => showPurge(), text: "Purge the list (finished reconciling)" },
        { unique: "E", key: KBD.E, action: () => showExportCounts(), text: "Export the counts to a CSV file" },
        // { unique: "N", key: KBD.N, action: () => showFindInventory(), text: "Find inventory records with a negative onhand" },
        // { unique: "Z", key: KBD.Z, action: () => showZeroCounts(), text: "Zero counts for all items on this list" },
        { unique: "S", key: KBD.S, action: () => showSoundSetup(), text: "Sound settings" },
        // { unique: "C", key: KBD.C, action: () => { }, text: "Disable choosing the condition when EANs with multiple conditions exist" },

    ]

    const [selected, setSelected] = useState(unique);

    const onEnter = (_sel) => {
        let _f = menu.find(item => item.unique === _sel);
        if (_f) {
            _f.action();
        }
    }

    useEffect(() => {

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(selected) } },
            { key: KBD.ENTER, action: (e) => { onEnter(selected) } },
        ];

        const cleanup = listen(controller, route, actions.concat(menu), false, [KBD.ENTER, KBD.ESCAPE]);
        return cleanup;
    }, [selected]);


    return (
        <div style={{ "width": "660px" }}>
            <div className="shim" /><div className="shim" />
            <Menu controller={controller} callback={(e) => e.action()} bordered keyName="unique" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} />
        </div>
    )
}